import React from 'react';

import ChevronRightIcon from 'icons/chevron-right.svg';
import PropTypes from 'prop-types';

import BreadCrumb, {
  propsShape as breadCrumbPropsShape,
} from 'components/application/BreadCrumb';

export default function BreadCrumbList({ breadCrumbOptions, leadingIcon }) {
  return (
    <div className='tw-flex tw-flex-wrap tw-items-center tw-gap-y-1'>
      {leadingIcon}
      {breadCrumbOptions.map((breadCrumbProps, index) => {
        const isCurrentLocation =
          index > 0 && index === breadCrumbOptions.length - 1;

        return (
          <React.Fragment key={`breadcrumb--${index}`}>
            {index > 0 && (
              <ChevronRightIcon
                className='[&_polygon]:tw-fill-grey-700'
                height={20}
                width={20}
              />
            )}
            <BreadCrumb
              {...breadCrumbProps}
              isConstrained={index > 0 && !isCurrentLocation}
              onClick={isCurrentLocation ? undefined : breadCrumbProps.onClick}
            />
          </React.Fragment>
        );
      })}
    </div>
  );
}

BreadCrumbList.propTypes = {
  breadCrumbOptions: PropTypes.arrayOf(PropTypes.shape(breadCrumbPropsShape)),
  leadingIcon: PropTypes.node,
};
